// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__1JBDR","form":"style_form__gndMY","required-mark":"style_required-mark__2ZSB8","input-container":"style_input-container__139SU"};